<template>
  <!-- 14会议微网站 -->
  <div class="academic-section" @click="go(dataItem)">
    <img :src="dataItem.cover_img" class="academic-section-img"/>
    <div class="academic-section-content">
      <div class="academic-section-content-title">{{ dataItem.title }}</div>
      <div class="academic-section-content-detail" v-if="dataItem.academic_origin_type == 14 && dataItem.meeting_status != 2">
        <span v-if="dataItem.isApply" class="academic-section-content-detail-btn">已报名</span>
        <span v-else class="academic-section-content-detail-btn" @click.stop="$router.push('/login')">报名参会</span>
      </div>
      <div class="academic-section-content-detail" v-else>
        {{ dataItem.start_at}}
      </div>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "academic",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // applyShow: false
    }
  },
  methods: {
    go(item) {
      // return
      if (item.content.academic_origin_type == 4) {
        // 直播
        this.$router.push({name: 'live-detail', params: { id: item.id }})
      } else if (item.academic_origin_type == 31) {
        // 会议
        Interface.goMeeting(this,item)
        // window.location.href = 'https://conference-h5.dr-gobroad.com/#/r?m=' + item.content.uuid
      } else if (item.academic_origin_type == 13) {
        this.$router.push({name: 'topic-detail', params: { id: item.id }})
      }
    },
  }
}
</script>

<style scoped lang="scss">
.academic-section{
  padding-bottom: 16px;
  &-img{
    width: 100%;
    height: 102px;
    background: linear-gradient(180deg, #ECEFF6 0%, #D7DFF3 100%);
    border-radius: 6px;
  }
  .van-image__img{
    width: 180px;
    height: 102px;
    border-radius: 6px;
  }
  &-content{
    height: 62px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 0 0 0;
    &-title{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    &-detail{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #979797;
      &-btn{
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #D81D20;
        padding: 3px 7px;
        background: #FFF0EE;
        border-radius: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/horizontalRecommend/academic.vue